import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "error-label" }
const _hoisted_2 = { class: "error-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VeeError = _resolveComponent("VeeError")!

  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "label"),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.languages, (l) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        ((l.id || l.value) == $props.language)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent($props.innerComponent), _mergeProps({
              key: 0,
              id: (l.id || l.value),
              ref_for: true
            }, _ctx.$attrs, {
              name: `${$setup.name}.${(l.id || l.value)}`,
              "onUpdate:modelValue": $event => $setup.setValue($event, (l.id || l.value)),
              "model-value": $setup.localForm[(l.id || l.value)],
              languages: $props.languages,
              onSetRules: $setup.updateRules
            }), _createSlots({ _: 2 }, [
              _renderList(_ctx.$slots, (_, name) => {
                return {
                  name: name,
                  fn: _withCtx((bound) => [
                    ('label' !== name)
                      ? _renderSlot(_ctx.$slots, name, _mergeProps({
                          key: 0,
                          ref_for: true
                        }, bound || {}))
                      : _createCommentVNode("", true)
                  ])
                }
              })
            ]), 1040, ["id", "name", "onUpdate:modelValue", "model-value", "languages"]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_VeeError, {
          name: `${$setup.name}.${(l.id || l.value)}`
        }, {
          default: _withCtx(({ message }) => [
            _createElementVNode("div", _hoisted_1, _toDisplayString(l.title) + ": " + _toDisplayString(message), 1)
          ]),
          _: 2
        }, 1032, ["name"]), [
          [_vShow, (l.id || l.value) !== $props.language]
        ])
      ], 64))
    }), 256)),
    _createVNode(_component_VeeError, {
      name: `${$setup.name}.${$setup.default_language}`
    }, {
      default: _withCtx(({ message }) => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(message), 1)
      ]),
      _: 1
    }, 8, ["name"]),
    _renderSlot(_ctx.$slots, "errors", { languages: $props.languages })
  ]))
}